<!-- qesg-dash-card -->
<template>
    <b-card :class="['dash-card shadow-sm', {horizontal: align === 'horizontal'}]" border-variant="0">
        <template v-if="align === 'vertical'">
            <b-row>
                <b-col cols="12" class="mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 :class="['dash-card-title mr-2 mb-0', titleClass]">{{ title }}</h5>
                        <qesg-dash-card-icon :icon="icon" :variant="iconVariant" :font-scale="iconFontScale" />
                    </div>
                </b-col>
                <b-col cols="12">
                    <h2 class="mb-0">{{ index }}</h2>
                </b-col>
            </b-row>
        </template>
        <template v-else>
            <b-row align-v="center" class="h-100">
                <b-col cols="auto">
                    <qesg-dash-card-icon
                        class="justify-content-center p-3"
                        :icon="icon"
                        :variant="iconVariant"
                        :font-scale="iconFontScale"
                        />
                </b-col>
                <b-col col class="h-100">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <h1 class="mb-0">{{ index }}</h1>
                        <h6 class="dash-card-title mr-2 mb-0">{{ title }}</h6>
                    </div>
                </b-col>
            </b-row>
        </template>
    </b-card>
</template>

<script>
import qesgDashCardPropsDefault from '@shared_mixins/contractor-dashboard/qesg-dash-card-props-default.js';
import qesgDashCardPropsIcon from '@shared_mixins/contractor-dashboard/qesg-dash-card-props-icon.js';
import qesgDashCardIcon from '@shared_components/contractor/components/qesg-dash-card-icon.vue';

export default {
    name: 'qesg-dash-card',
    components: {
        qesgDashCardIcon
    },
    mixins: [
        qesgDashCardPropsDefault,
        qesgDashCardPropsIcon
    ],
    props: {
        align: {
            type: String,
            required: false,
            default: 'vertical' // 'horizontal', 'vertical'
        },
        index: {
            type: String,
            required: true
        }
    },
    computed: {}
}
</script>

<style>

</style>